import { useParams } from "react-router-dom";
import { MarketingLayout } from "@/components/MarketingLayout";
import { AuditResults } from "@/components/audit/AuditResults";

export default function AuditResultsPage() {
  const { id } = useParams<{ id: string }>();
  if (!id) return null;
  return (
    <MarketingLayout>
      <div className="max-w-4xl mx-auto w-full px-6 py-12">
        <AuditResults auditId={id} />
      </div>
    </MarketingLayout>
  );
}
